<template>
    <div id="oftenList" class="importTable">   
            <div class="css_table">
            <div class="css_tr importTitle">
                <div class="css_td">姓名</div>
                <div class="css_td">英文名字</div>
                <div class="css_td">身分證字號</div>
                <div class="css_td">英文護照</div>
                <div class="css_td">生日</div>
                <div class="css_td">地址</div>
                <div class="css_td">選擇</div>
                <div class="css_td">刪除</div>
            </div>
            <div class="css_tr dataFrame" v-for="(traveler, index) in travelerList" :key="index">
                <div class="css_td"><span class="tlf_r_f1" :id="'oftenName'+index">{{ traveler.insuredName }}</span><div class="mobileInsert"><a @click="setInsure(traveler)">匯入</a> <a @click="deleteTraveler(traveler)">刪除</a></div></div>
                <div class="css_td"><span :id="'insuredEngName'+index">{{ traveler.insuredEngName }}</span></div>
                <div class="css_td"><span class="tlf_n_l5" :id="'oftenIdNo'+index">{{ traveler.insuredIdNo }}</span></div>
                <div class="css_td"><span :id="'passportNo'+index">{{traveler.passportNo}}</span></div>
                <div class="css_td"><span class="tlf_n_dash1" :id="'oftenBirth'+index">{{ traveler.insuredBirthday }}</span></div>
                <div class="css_td"><span :id="'address'+index">{{traveler.insuredCityName}}{{traveler.insuredZipName}}{{traveler.insuredAddress}}</span></div>
                <div class="css_td hide"><a @click="setInsure(traveler)">匯入</a></div>
                <div class="css_td hide"><a @click="deleteTraveler(traveler)">刪除</a></div>
            </div>
        </div>
    </div>
</template>
<script setup>
        import { getApi, postApi } from "@/utils/callApi";
        import {onMounted, ref} from "vue";
        import apiConfig from "@/utils/apiConfig";
        import Swal from "sweetalert2";
        import {useRouter} from "vue-router";
        const emits = defineEmits(["traveler"]);
        const router = useRouter();

        let jwtInfo = [];
        const travelerList = ref();

        const getTravelerList = () => {
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            if (jwtInfo != null) {
                getApi(apiConfig.getTraveler, jwtInfo.token)
                    .then((response) => {
                        var getTravelerRes = response.data;
                        if (getTravelerRes.code === 200) {
                            travelerList.value = getTravelerRes.data;
                        } else {
                            //跳出錯誤
                            Swal.fire({
                                title: "頁面載入錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>'+ getTravelerRes.message + '</p>',
                            });
                        }
                    })
                    .catch(() => {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>常用清單載入錯誤</p>',
                        })
                    })
            } else {
                Swal.fire({
                    title: "尚未登入",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>請進行登入後繼續</p>',
                }).then(() => {
                    router.push('/login');
                });
            }

        }
        const setInsure = (traveler) => {
            var travelerData = {
                insureName: traveler.insuredName,
                insureIdNo: traveler.insuredIdNo,
                insureBirthday: traveler.insuredBirthday,
                insuredEngName: traveler.insuredEngName,
                passportNo:traveler.passportNo,
                insuredCityCode:traveler.insuredCityCode,
                insuredCityCodeId:traveler.insuredCityCodeId?traveler.insuredCityCodeId:"",
                insuredZipCode:traveler.insuredZipCode,
                insuredZipCodeId:traveler.insuredZipCodeId?traveler.insuredZipCodeId:"",
                insuredAddress:traveler.insuredAddress
            }

            emits('traveler', travelerData);
        }
        const deleteTraveler = (traveler) => {
            var data = {
                'id': traveler.id,
            }
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            if (jwtInfo != null) {
                postApi(apiConfig.delTraveler, jwtInfo.token, null, null, data)
                    .then((response) => {
                        var delTravelerRes = response.data;
                        if (delTravelerRes.code === 200) {
                            Swal.fire({
                                title: "刪除常用清單",
                                showConfirmButton: true,
                                confirmButtonText: '確定',
                                showCloseButton: true,
                                html: '<img src="successmark.svg" alt="success"><p>刪除成功</p>',
                            }).then(() => {
                                getTravelerList();
                            });
                        } else {
                            //跳出錯誤
                            Swal.fire({
                                title: "刪除常用清單錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>'+ delTravelerRes.message + '</p>',
                            });
                        }
                    })
                    .catch(() => {
                        //跳出錯誤
                        Swal.fire({
                            title: "刪除常用清單錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>連線錯誤</p>',
                        })
                    })
            } else {
                Swal.fire({
                    title: "尚未登入",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>請進行登入後繼續</p>',
                }).then(() => {
                    router.push('/login');
                });
            }
        }
        onMounted(()=>{
            getTravelerList();
        });

</script>
<style lang="scss">
#oftenList {
    .css_table{border-radius:10px;width:95%;border:1px solid $gray;margin:45px auto 20px;font-weight:500;
        @media screen and (max-width: $padLandscape) {
            width:90%;
        }
    }
    .css_td {
      line-height:25px;
        a {
            cursor: pointer;
        }
      @media screen and (max-width: $padLandscape) {
        font-size:1.2vw;

        a{font-size:1.2vw;}
      }
    }

    .css_tr {
        &.importTitle {
          .css_td{color: #fff;}
            @media screen and (max-width: $small) {
                display:none;
  
            }
        }
    }
    .mobileInsert{display:none}
    @media screen and (max-width: $small) {
        .css_table{border:0;
        margin:10px auto;
        }
        .dataFrame{
            border:1px solid $gray;
            margin:10px 0;
            overflow:hidden;
            display:block;
            border-radius:10px;
            .css_td{
              display: block;
              padding: 0;
              border: 0;
              line-height: 1.5rem;
              text-align: left;
              text-indent: 10px;
              font-size: 0.8rem;

                a{margin:0 3px;font-size:15px;}
                &.hide{display:none;}
                span {
                  display: inline-block;
                }
            }
            .css_td::before{
                display:inline-block;
                text-align:left;
                width:33%;
                float:left;
                background:$blue-700;
                color:#fff;
            }
            .css_td:nth-of-type(1){border-bottom:1px solid $btnGray;}
            .css_td:nth-of-type(1)::before{
                content:'姓名';
                border-bottom: 1px solid $blue-700;
            }
            .css_td:nth-of-type(2)::before{
                content:'英文名字';
            }
            .css_td:nth-of-type(3)::before{
                content:'身分證字號';
            }
          .css_td:nth-of-type(4)::before{
            content:'英文護照';
          }
          .css_td:nth-of-type(5)::before{
            content:'生日';
          }
          .css_td:nth-of-type(6)::before{
            content:'地址';
          }
        }
        .mobileInsert{display:block;float:right;margin-right:3px;}
    }
}
@media screen and (max-width: $small){
  #oftenList{
    height:70vh;
    overflow-y:scroll;
  }
}

</style>